// Copyright (c) 2016 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const ShippingInstruction = () =>
    <div className='shipping-instruction'>
        <a
            href='http://dlrdoc.deere.com/ag_cust_supp/warrSysResources/Return_Parts_LP.pdf'
            rel='noopener noreferrer'
            target='_blank'
        >
            <FormattedMessage id='SHIPPING_INSTRUCTIONS'/>
        </a>
    </div>;

ShippingInstruction.displayName = 'ShippingInstruction';

export default ShippingInstruction;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/shipping-instruction.js